import { render, staticRenderFns } from "./shareBtn.vue?vue&type=template&id=42549a36&scoped=true"
import script from "./shareBtn.vue?vue&type=script&lang=js"
export * from "./shareBtn.vue?vue&type=script&lang=js"
import style0 from "./shareBtn.vue?vue&type=style&index=0&id=42549a36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42549a36",
  null
  
)

export default component.exports